import angular from 'angular';
import EnvelopeFilters from '../envelope-filters.data';

class evlWaitingCtrl {
    /* @ngInject */
    constructor(
        $scope,
        $uibModal,
        $filter,
        $sessionStorage,
        $translate,
        AuthSvc,
        dateFilter,
        toastr,
        EnvelopeService,
        PrincipalService,
        uiGridConstants,
        UtilSvc
    ) {
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.$sessionStorage = $sessionStorage;
        this.$translate = $translate;
        this.AuthSvc = AuthSvc;
        this.dateFilter = dateFilter;
        this.toastr = toastr;
        this.EnvelopeService = EnvelopeService;
        this.PrincipalService = PrincipalService;
        this.uiGridConstants = uiGridConstants;
        this.UtilSvc = UtilSvc;
    }

    $onInit() {
        // Accès raccourcis aux autorisations depuis le scope principal
        this.isAuthorized = this.AuthSvc.isAuthorized;

        this.principals = this.PrincipalService.findAll();

        this.criteria = {
            envelopeId: [],
            envelopeStatus: 'ID_TEMP',
            sender: [],
            refClient: [],
            createdDateFrom: [],
            receiver: undefined,
            createdDateTo: [],
            createdTimeFrom: [],
            createdTimeTo: [],
        };

        this.criteriaWaiting = {
            envelopesIds: [],
            generateBatchPlatform: false,
            ladProviderIdPlatform: undefined,
            generateBatchQuali: false,
            ladProviderIdQuali: undefined,
            excludeBatchSendedOrLinkToMessage: false,
        };

        this.selected = {
            principal: null,
        };

        this._initEnvelopesSearchFilter();
        this._initEnvelopesSearchValues();

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="envelope_details({ envelopeId : row.entity.envelopeId, activeTabName: $scope.activeTabName })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        var statusCellTemplate =
            '<a class="grid-cell-link" ui-sref="envelope_details({ envelopeId : row.entity.envelopeId, activeTabName: $scope.activeTabName })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD | translate}} {{row.entity.row.entity.envelopeStatus}}<span ng-if="row.entity.envelopeStatus == \'ERROR\'">{{"status.error_" + row.entity.envelopeErrorCode | translate}}</span></div></a>';
        var mailCellTemplate =
            '<a class="grid-cell-link" ui-sref="envelope_details({ envelopeId : row.entity.envelopeId, activeTabName: $scope.activeTabName })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer"><span class="ui-grid-cursor-pointer" ng-click="grid.appScope.$ctrl.showMailContent(row)"><u>Voir</u></span></div></a>';

        this.gridOptions = {
            columnDefs: [
                {
                    name: 'envelopeId',
                    displayName: 'dashboard.column.envelope.id',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    type: 'number',
                },
                {
                    name: 'created',
                    displayName: 'dashboard.column.envelope.created',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    sort: { direction: this.uiGridConstants.DESC, priority: 0 },
                    cellFilter: "date:'short'",
                },
                {
                    name: 'envelopeStatus',
                    displayName: 'dashboard.column.envelope.status',
                    cellTemplate: statusCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'receiver',
                    displayName: 'dashboard.column.envelope.receiver',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'sender',
                    displayName: 'dashboard.column.envelope.sender',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'sentDate',
                    displayName: 'dashboard.column.envelope.sent_date',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: "date:'short'",
                },
                {
                    name: 'refClient',
                    displayName: 'dashboard.column.envelope.reference',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'size',
                    displayName: 'dashboard.column.envelope.size',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: 'bytes',
                },
                {
                    name: 'mail',
                    displayName: 'dashboard.column.envelope.mail',
                    cellTemplate: mailCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: 'bytes',
                },
            ],
            enableGridMenu: false,
            enableRowSelection: true,
            enableSelectAll: true,
            selectionRowHeaderWidth: 30,
            exporterMenuCsv: false,
            exporterMenuPdf: false,
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            enableColumnMenus: false,
            exporterHeaderFilter: this.$translate.instant,
            exporterFieldCallback: (grid, row, col, value) => {
                if (col.name === 'created' || col.name === 'sentDate') {
                    value = this.dateFilter(value, 'short');
                } else if (col.name === 'size') {
                    value = this.$filter('bytes')(value);
                } else if (col.name === 'envelopeStatus') {
                    var origValue = value;
                    value = this.$translate.instant(value);
                    if (origValue === 'ERROR') {
                        value =
                            this.$translate.instant(value) +
                            ' ' +
                            this.$translate.instant('status.error_' + row.entity.envelopeErrorCode);
                    }
                }
                return value;
            },
            gridMenuTitleFilter: this.$translate,
            onRegisterApi: gridApi => {
                this.gridEnvelopesApi = gridApi;
            },
        };

        // init
        var waitingHistorySearchCriteria = this.$sessionStorage.waitingHistorySearchCriteria;
        var waitingHistorySearchCriteriaBis = this.$sessionStorage.waitingHistorySearchCriteriaBis;
        if (waitingHistorySearchCriteria) {
            this.criteria = waitingHistorySearchCriteria;
        }
        if (waitingHistorySearchCriteriaBis) {
            this.selected = waitingHistorySearchCriteriaBis;
        }
    }

    clearSearchEnvelopes() {
        this._initEnvelopesSearchFilter();
        this._initEnvelopesSearchValues();
        this.gridOptions.data = this.EnvelopeService.searchByCriterias(this.criteria, (/*data*/) => {});
    }

    searchEnvelopes() {
        this.criteria.principalId = this.selected.principal && this.selected.principal.principalId;
        this.criteria.senderName =
            this.selected.seller && this.selected.seller.legalEntity && this.selected.seller.legalEntity.name;
        this.$sessionStorage.waitingHistorySearchCriteria = this.criteria;
        this.$sessionStorage.waitingHistorySearchCriteriaBis = this.selected;

        var criterias = new EnvelopeFilters();
        var createdDateFrom = this.UtilSvc.mixteDateTime(this.criteria.createdDateFrom, this.criteria.createdTimeFrom);
        criterias.setCreatedDateFrom(createdDateFrom);
        var createdDateTo = this.UtilSvc.mixteDateTime(this.criteria.createdDateTo, this.criteria.createdTimeTo);
        criterias.setCreatedDateTo(createdDateTo);
        criterias.setRefClient(this.criteria.refClient);
        criterias.setSenderName(this.criteria.senderName);
        criterias.setEnvelopeStatus(this.criteria.envelopeStatus);
        criterias.setEnvelopeId(this.criteria.envelopeId);
        criterias.setReceiver(this.criteria.receiver);
        this.gridOptions.data = this.EnvelopeService.searchByCriterias(criterias);
        this.waitingPromise = this.gridOptions.data.$promise;
    }

    affectWaitingEnvelope() {
        var envelopeIds = this._getSelectedRows();
        var modalInstance = this.$uibModal.open({
            animation: true,
            component: 'chooseContainerModal',
            resolve: {
                envelopeSize: envelopeIds.length,
                principals: () => {
                    return this.principals;
                },
            },
        });
        modalInstance.result.then(
            data => {
                this.EnvelopeService.affectContainer(
                    { envelopeIds: envelopeIds, containerId: data.containerId, motif: data.motif },
                    (/*result*/) => {
                        this.toastr.success(
                            this.$translate.instant('dashboard.column.envelope.success_affect'),
                            this.$translate.instant('dashboard.column.envelope.success_title'),
                            { timeOut: 7000 }
                        );
                        this.searchEnvelopes();
                    },
                    (/*error*/) => {
                        this.toastr.error("Une erreur s'est produite");
                    }
                );
            },
            function () {}
        );
    }

    rejectWaitingEnvelope() {
        var envelopeIds = this._getSelectedRows();
        var modalInstance = this.$uibModal.open({
            animation: true,
            component: 'rejectEnvelopeModal',
            resolve: {
                envelopeIds: () => {
                    return envelopeIds;
                },
            },
        });
        modalInstance.result.then(
            motif => {
                this.EnvelopeService.rejectEnvelope(
                    { envelopeIds: envelopeIds, motif: motif },
                    (/*result*/) => {
                        this.toastr.success(
                            this.$translate.instant('dashboard.column.envelope.success_reject'),
                            this.$translate.instant('SAVE_SUCCESS'),
                            { timeOut: 7000 }
                        );
                        this.searchEnvelopes();
                    },
                    (/*error*/) => {
                        this.toastr.error("Une erreur s'est produite");
                    }
                );
            },
            () => {}
        );
    }

    // Indique si l'export CSV de la grille peut être réalisé
    canExportGrid() {
        if (!(this.gridEnvelopesApi === undefined || this.gridEnvelopesApi.selection === undefined)) {
            return this.gridEnvelopesApi.selection.getSelectedRows().length > 0;
        }
        return false;
    }

    // Exporte toutes les colonnes des lignes sélectionnées dans un fichier CSV
    exportGridCsv() {
        // Nom du fichier CSV : epdf_DateHeure_dataPlis.csv
        var filename = 'PlisEnAttenteDeContainer.csv';
        this.gridOptions.exporterCsvFilename = filename;

        var myElement = angular.element(document.querySelectorAll('.custom-csv-link-location'));
        this.gridEnvelopesApi.exporter.csvExport('selected', 'all', myElement);
    }

    getTableHeight() {
        var rowHeight = 30;
        var headerHeight = 30;
        var scrollHeight = 20;
        var footerHeight = 32;
        return {
            height:
                this.gridEnvelopesApi.core.getVisibleRows(this.gridEnvelopesApi.grid).length * rowHeight +
                headerHeight +
                scrollHeight +
                footerHeight +
                'px',
        };
    }

    // Affichage de la fenêtre detaillant le contenu d'une enveloppe.
    showMailContent(row) {
        this.EnvelopeService.get({ envelopeId: row.entity.envelopeId }, data => {
            return this.$uibModal
                .open({
                    component: 'envelopeContent',
                    size: 'lg',
                    resolve: {
                        envelope: data,
                    },
                })
                .result.then(
                    function () {},
                    function () {}
                );
        });
    }

    _getSelectedRows() {
        var envelopeIds = [];
        var selectedRows = this.gridEnvelopesApi.selection.getSelectedRows();
        for (var i = 0; i < selectedRows.length; i++) {
            envelopeIds.push(selectedRows[i].envelopeId);
        }
        return envelopeIds;
    }

    _initEnvelopesSearchValues() {
        this.criteria.createdTimeFrom = new Date();
        this.criteria.createdTimeFrom.setHours(0, 0, 0, 0);
        this.criteria.createdTimeTo = new Date();
        this.criteria.createdTimeTo.setHours(23, 59, 0, 0);
    }

    _initEnvelopesSearchFilter() {
        this.criteria.envelopeId = undefined;
        this.criteria.sender = undefined;
        this.criteria.refClient = undefined;
        this.criteria.createdDateFrom = undefined;
        this.criteria.createdDateTo = undefined;
        this.criteria.createdTimeFrom = undefined;
        this.criteria.createdTimeTo = undefined;
    }
}

angular.module('evl-waiting').component('evlWaiting', {
    templateUrl: require('./waiting.html'),
    controller: evlWaitingCtrl,
});
